import { deliveryIDVar } from 'app/apollo/reaction';
import React, {
    useReducer, useContext, useMemo, useEffect,
    createContext,
} from 'react';
import { useLocation } from 'react-router';

const initialState = {
    segment: 'initial',
};

/*
        const isProfile = useMemo<boolean>(
        () => {
            const regex = /^\/(profile)(\/.*)?$/;
            return regex.test(pathname);
        },
        [pathname],
    );

    const isDeliveryMenu = useMemo(() => {
        const regex = /^\/(app\/delivery)(\/.*)?$/;
        return regex.test(pathname);
    }, [pathname]);


*/


export const PathSegmentContext = createContext(initialState);

// eslint-disable-next-line react/prop-types
export const PathSegmentProvider = ({ children }) => {
    const { pathname } = useLocation();


    useEffect(() => {
        const deliveryIDRegex = /app\/delivery\/(\d+)/;
        const match = pathname.match(deliveryIDRegex);
        const deliveryId = match ? match[1] : null;
        // console.log(deliveryId);
        deliveryIDVar(deliveryId);
    }, [pathname]);

    const contextValue = useMemo(() => {
        const deliveryRegex = /^\/(app\/delivery)(\/.*)?$/;
        switch (true) {
            case deliveryRegex.test(pathname):
                return { segment: 'delivery' };
            default: return { segment: 'new' };
        }
    }, [pathname]);


    // console.log(contextValue);

    return (
        <PathSegmentContext.Provider value={contextValue}>
            {children}
        </PathSegmentContext.Provider>
    );
};
